const WISHLIST_KEY = 'shopify_custom_wishlist';

// Retrieve wishlist from localStorage
function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  } catch (e) {
    return [];
  }
}

// Save wishlist to localStorage and refresh UI
function saveWishlist(wishlist) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
  updateWishlistUI();
}

// Toggle item in wishlist
function toggleWishlist(handle) {
  let wishlist = getWishlist();
  const index = wishlist.indexOf(handle);
  if (index === -1) {
    wishlist.push(handle);
  } else {
    wishlist.splice(index, 1);
  }
  saveWishlist(wishlist);
}

// Update all wishlist buttons, counts, and pages on the site
function updateWishlistUI() {
  const wishlist = getWishlist();

  // 1. Update all header counts
  const countBadges = document.querySelectorAll('[data-wishlist-count]');
  countBadges.forEach(badge => {
    badge.textContent = wishlist.length;
    if (wishlist.length > 0) {
      badge.classList.remove('hidden');
    } else {
      badge.classList.add('hidden');
    }
  });

  // 2. Update all toggle buttons on the page
  const buttons = document.querySelectorAll('[data-wishlist-button]');
  buttons.forEach(btn => {
    const handle = btn.getAttribute('data-product-handle');
    const isAdded = wishlist.includes(handle);
    const svg = btn.querySelector('svg');
    const textSpan = btn.querySelector('[data-wishlist-text]');

    if (svg) {
      if (isAdded) {
        svg.setAttribute('fill', 'currentColor');
        svg.classList.add('text-red-500');
        svg.classList.remove('text-primary-text');
      } else {
        svg.setAttribute('fill', 'none');
        svg.classList.remove('text-red-500');
        svg.classList.add('text-primary-text');
      }
    }

    if (textSpan) {
      textSpan.textContent = isAdded ? 'Remove from Wishlist' : 'Add to Wishlist';
    }
  });

  // 3. Render wishlist items if we are on the wishlist page template
  const pageContainer = document.querySelector('[data-wishlist-page-container]');
  if (pageContainer) {
    renderWishlistPage(wishlist);
  }
}

// Dynamically fetch and display products on the wishlist page
function renderWishlistPage(wishlist) {
  const container = document.querySelector('[data-wishlist-page-container]');
  if (!container) return;

  if (wishlist.length === 0) {
    container.innerHTML = `
      <div class="text-center py-16">
        <p class="text-lg text-primary-text-80 mb-6 font-body">Your wishlist is currently empty.</p>
        <a href="/collections/all" class="button button--primary inline-block py-3 px-6 text-sm uppercase font-navigation font-bold tracking-wider rounded-md">Continue Shopping</a>
      </div>
    `;
    return;
  }

  // Create grid structure matching theme collections
  container.innerHTML = `
    <div class="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-7" id="WishlistGrid">
      <!-- Dynamically loaded product cards go here -->
    </div>
  `;
  const grid = document.getElementById('WishlistGrid');

  wishlist.forEach(handle => {
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        const formattedPrice = Shopify.formatMoney 
          ? Shopify.formatMoney(product.price, window.theme?.moneyFormat || "${{amount}}") 
          : `Rs. ${(product.price / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

        const productUrl = product.url;
        const featuredImage = product.featured_image || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1.png';

        const cardHtml = `
          <div class="product-card flex flex-col relative h-full bg-primary-secondary-background p-3 rounded group" data-product-card="${product.id}">
            <!-- Remove Button -->
            <button 
              type="button" 
              class="absolute top-4 right-4 z-30 p-1.5 rounded-full bg-white shadow-md text-primary-text hover:text-red-500 transition-colors duration-200"
              aria-label="Remove item"
              onclick="toggleWishlist('${product.handle}')"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 pointer-events-none">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>
            <a href="${productUrl}" class="block overflow-hidden rounded mb-3">
              <img src="${featuredImage}" alt="${product.title}" class="w-full h-48 object-contain transition-transform duration-300 group-hover:scale-105" loading="lazy">
            </a>
            <h3 class="font-navigation text-sm font-bold mt-1 text-center">
              <a href="${productUrl}" class="hover:text-primary-accent block leading-snug">${product.title}</a>
            </h3>
            <p class="text-xs text-primary-text-80 mt-1 text-center font-navigation font-bold">${formattedPrice}</p>
            <a href="${productUrl}" class="button button--primary button--full-width mt-auto text-xs py-2 text-center uppercase tracking-wide font-bold">View Product</a>
          </div>
        `;
        grid.insertAdjacentHTML('beforeend', cardHtml);
      })
      .catch(err => {
        console.error('Error loading wishlist product:', err);
      });
  });
}

// Global hook for onclick events in dynamically generated content
window.toggleWishlist = toggleWishlist;

// Listen to clicks on toggle buttons (use capture phase to preempt third-party scripts)
// Registered immediately on script load to capture events as early as possible
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-wishlist-button]');
  if (btn) {
    e.preventDefault();
    e.stopPropagation(); // Stop event bubbling to parent <a> tags and other handlers
    const handle = btn.getAttribute('data-product-handle');
    if (handle) {
      toggleWishlist(handle);
    }
  }
}, true);

// Initialize UI on page load
function initWishlistUI() {
  updateWishlistUI();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlistUI);
} else {
  initWishlistUI();
}
